<div *ngIf="loaderType !== 'state-loader'">

<div
  class="skeleton d-flex align-items-center {{ skeletonLoaderClass }}"
  [ngClass]="{
    'flex-row': isHorizontal,
    'flex-column': !isHorizontal,
    ' p-0': loaderType == 'recommendedSchemes',
      'h-100': loaderType === 'state-filter',
      'p-0': loaderType == 'schemesform'

      
  }"
  [ngStyle]="{ minHeight: loaderType == 'recommendedSchemes' ? '80px' : loaderType == 'schemesform' ? '77px': '', border: loaderType == 'recommendedSchemes' ? '1px solid #eeeeee' : ''}"
>
  <div class="skeleton-left" 
  [ngClass]="{ 'mt-0': isHorizontal,
  'd-none': loaderType == 'recommendedSchemes',
'mb-0':loaderType=='schemesform' }"
  >
    <div class="top top--circle"></div>
  </div>
  <div
    class="skeleton-right w-100 d-flex flex-column"
    [ngClass]="{
      'align-items-start ps-3': isHorizontal,
      'align-items-center': !isHorizontal
    }"
  >
    <div class="line h17 w90 mb-3"></div>
    <div class="line h4 w75" [ngClass]="{ 'd-none': loaderType == 'schemesform' }"></div>
    <div class="line h4 w75"></div>
  </div>
</div>
</div>

<div *ngIf="loaderType === 'state-loader'">
  <div *ngIf="filterLoader === 'filter'" class="skeleton skeleton-full-page">
    <div *ngFor="let time of totalTime">
      <div class="line h17 w90 mb-3"></div>
      <div class="line h4 w75"></div>
      <div class="line h4 w75 mb-3"></div>
    </div>
  </div>

  <div *ngIf="filterLoader === 'detail'" [ngClass]="{'skeleton skeleton-full-page': cardType === 'square'}">
    <div class="line search-loader h50 w-100 mb-3"></div>
    <div *ngIf="showBannerLoader" class="line search-loader h200 w-100 mb-3"></div>

    <div *ngIf="cardType === 'square'" class="row">
      <div *ngFor="let time of totalTime" class="col-md-4 pt-2">
        <div class="skeleton b-radius-12 h-100">
          <div class="d-flex justify-content-center align-items-center mb-1">
            <div class="top top--circle"></div>
          </div>
          <div class="d-flex justify-content-center align-items-center mb-1">
            <div class="line h17 w90 mb-3"></div>
          </div>
          <div class="d-flex justify-content-center align-items-center mb-1">
            <div class="line h4 w75"></div>
          </div>
          <div class="d-flex justify-content-center align-items-center mb-1">
            <div class="line h4 w75"></div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="cardType === 'scheme-show'" class="row">
      <div *ngFor="let time of exploreSchemes" class=" col-md-3 pt-2 scheme-tiles">
        <div class="skeleton b-radius-12 h-100">
          <div class="d-flex justify-content-start  mb-1">
            <div class="top top--square"></div>
          </div>
          <div class="d-flex justify-content-start  mb-1">
            <div class="line h17 w90 mb-3"></div>
          </div>
          <div class="d-flex justify-content-start  mb-1">
            <div class="line h17 w90 mb-3"></div>
          </div>
         
        </div>
      </div>
    </div>
    
  </div>
  <div *ngIf="filterLoader === 'list-rectangle'" class="skeleton border-0 ps-4">
    <div *ngFor="let time of stateTotalTime.slice(0,5)">
      <div class="d-flex" style="border-bottom: 1px solid  rgba(232, 232, 232, 1);
      margin-bottom: 10px;">
        <div class="line h32 w2 me-3 mb-3">

        </div>
        <div class="w-100">
          <div class="line h12 w15"></div>
          <div class="line h12 w50"></div>
        </div>
      </div>
      
    </div>
  </div>
</div>